






















































import {Component, Vue} from 'vue-property-decorator';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import {Getter} from 'vuex-class';
import {workspacesApi} from '@/workspaces/workspaces';
import {UserViewModel} from '@/workspaces/models/userViewModel';
import moment from 'moment';
import InviteUser from '@/features/settings/components/InviteUser.vue';
import PageHeader from '@/shared/components/pageHeader/PageHeader.vue';
import ConfirmationModal from '@/shared/components/ConfirmationModal.vue';
import Toast from '@/shared/services/toast';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';

@Component({
	components: {
		InviteUser,
		PageHeader,
		ConfirmationModal,
		LoadingSpinner
	}
})
export default class UsersInWorkspace extends Vue {
	@Getter public currentWorkspace!: WorkspaceViewModel;

	public isLoading: boolean = false;
	private users: UserViewModel[] = [];

	private userToRemove: UserViewModel;
	private showInviteUserModal = false;
	private showRemoveUserModal = false;

	public async created(): Promise<void> {
		await this.getAllUsersForWorkspace();
	}

	public getStatus(status: number): string {
		if (status === 0) {
			return 'Pending';
		} else if (status === 1) {
			return 'Active';
		}
		return '';
	}

	public getStatusClass(status: number): string {
		if (status === 0) {
			return 'is-warning';
		} else if (status === 1) {
			return 'is-success';
		}
		return 'is-danger';
	}

	public formatDate(value: string): string {
		return moment(String(value)).format('DD MMM YYYY');
	}

	public openRemoveUserModal(user: UserViewModel): void {
		this.userToRemove = user;
		this.showRemoveUserModal = true;
	}

	public closeRemoveUserModal(): void {
		this.showRemoveUserModal = false;
	}

	public removeUser(): void {
		workspacesApi.revokeUser(this.userToRemove.id, this.currentWorkspace.id)
			.then(() => {
				Toast.showSuccess(`Successfully removed teammate ${this.userToRemove.userId}`);
			})
			.catch(err => Toast.showError(err.message))
			.finally(() => {
				this.getAllUsersForWorkspace();
				this.closeRemoveUserModal();
			});
	}

	public getConfirmationMessage(): string {
		return `Are you sure you want to remove ${this.userToRemove.userId} from ${this.currentWorkspace.name}?
		<br/><br/>
		Note that this will only remove their access to this workspace.`;
	}


	public openInviteUserModal() {
		this.showInviteUserModal = true;
	}

	public closeInviteUsersModal(refreshRequired: boolean) {
		if (refreshRequired) {
			this.getAllUsersForWorkspace();
		}
		this.showInviteUserModal = false;
	}

	private async getAllUsersForWorkspace() {
		this.isLoading = true;
		this.showRemoveUserModal = false;
		this.showInviteUserModal = false;
		this.users = await workspacesApi.getAllUsersForWorkspace(this.currentWorkspace.id);
		this.isLoading = false;
	}
}
